'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = catalogMiddleware;

var _constants = require('redux/constants');

var _catalog = require('redux/actions/catalog');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function catalogMiddleware() {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        return function (next) {
            return function (action) {
                switch (action.type) {
                    case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS:
                        next(action);
                        if (getState().catalog.hasUpdates) {
                            _reactSAlert2.default.info(getState().lang['notify.categories.updatingCatalog'], {
                                position: 'top-right',
                                effect: 'slide',
                                timeout: 2000
                            });
                        }
                        return;
                    default:
                        break;
                }

                return next(action);
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/catalogMiddleware.js
// module id = 1886
// module chunks = 0